import React from 'react';
import './ReceiptPreview.css';

const ReceiptPreview = ({
  businessName,
  businessLocation,
  businessNumber,
  evcNumber,
  edahabNumber,
  merchantNumber,
  orderNumber,
  waiterName,
  formattedDate,
  formattedTime,
  products,
  total,
  vatRate,
  vatAmount,
  grandTotal,
  paytoaccounts
}) => {

  const truncate = (text, maxLength) => {
    text = String(text || '');

    if (text.length <= maxLength) {
      return text;
    }

    return text.substring(0, maxLength - 3) + '...';
  };


  const formatProduct = (product) => {

    const qty =
      `${product.qty}x`;

    const item =
      truncate(product.name, 21);

    const price =
      `$${Number(
        product.salePrice || 0
      ).toFixed(2)}`;

    const itemTotal =
      Number(product.salePrice || 0) *
      Number(product.qty || 0);

    const totalPrice =
      `$${itemTotal.toFixed(2)}`;


    return {
      qty,
      item,
      price,
      totalPrice
    };
  };


  return (

    <div className="receipt-preview-wrapper">

      <div className="receipt-preview">


        {/* =================================
            TOP PADDING
        ================================= */}

        <div className="receipt-top-padding">
          <br />
          <br />
          <br />
          <br />
        </div>


        {/* =================================
            HEADER
        ================================= */}

        <div className="receipt-header">

          <div className="receipt-business-name">
            {businessName}
          </div>


          <div className="receipt-location">
            {businessLocation}
          </div>


          <div className="receipt-number">
            {businessNumber}
          </div>


      <div className="receipt-payment">
  {paytoaccounts?.map((payment, index) => (
    <div key={index}>
      {payment.label}: {payment.account}
    </div>
  ))}
</div>

        </div>


        {/* =================================
            SPACE AFTER HEADER
        ================================= */}

        <div className="receipt-small-space"></div>


        {/* =================================
            ORDER INFORMATION
        ================================= */}

        <div className="receipt-order-info">

          <div className="receipt-order-line">

            <span>
              ORDER: #{orderNumber}
            </span>

            <span>
              {formattedDate}
            </span>

          </div>


          <div className="receipt-order-line">

            <span>
              WAITER: {waiterName}
            </span>

            <span>
              {formattedTime}
            </span>

          </div>

        </div>


        {/* =================================
            SEPARATOR
        ================================= */}

        <div className="receipt-separator">
          {'-'.repeat(45)}
        </div>


        {/* =================================
            TABLE HEADER
        ================================= */}

        <div className="receipt-table-row receipt-table-header">

          <span className="receipt-qty">
            Qty
          </span>

          <span className="receipt-item">
            Item
          </span>

          <span className="receipt-price">
            Price
          </span>

          <span className="receipt-total">
            Total
          </span>

        </div>


        {/* =================================
            PRODUCTS
        ================================= */}

        <div className="receipt-products">

          {products?.map((product, index) => {

            const row =
              formatProduct(product);

            return (

              <div
                className="receipt-table-row"
                key={index}
              >

                <span className="receipt-qty">
                  {row.qty}
                </span>

                <span className="receipt-item">
                  {row.item}
                </span>

                <span className="receipt-price">
                  {row.price}
                </span>

                <span className="receipt-total">
                  {row.totalPrice}
                </span>

              </div>

            );

          })}

        </div>


        {/* =================================
            SEPARATOR
        ================================= */}

        <div className="receipt-separator">
          {'-'.repeat(45)}
        </div>


        {/* =================================
            TOTAL
        ================================= */}

        {/* With VAT, the three lines a tax receipt shows. Without it, one
            line, exactly as before. */}
        {Number(vatAmount || 0) > 0 ? (
          <React.Fragment>
            <div className="receipt-grand-total" style={{ fontWeight: 'normal' }}>
              <span>Total</span>
              <span>${Number(total || 0).toFixed(2)}</span>
            </div>

            <div className="receipt-grand-total" style={{ fontWeight: 'normal' }}>
              <span>{vatRate ? `VAT (${vatRate}%)` : 'VAT'}</span>
              <span>${Number(vatAmount || 0).toFixed(2)}</span>
            </div>
          </React.Fragment>
        ) : null}

        <div className="receipt-grand-total">

          <span>
            Wadarta Guud
          </span>

          <span>
            ${Number(grandTotal === undefined || grandTotal === null ? total : grandTotal || 0).toFixed(2)}
          </span>

        </div>


        {/* =================================
            FOOTER
        ================================= */}

        <div className="receipt-footer">

          <div>
            Mahadsanid, Soo noqosho wacan!
          </div>

          <div>
            Powered By Dalabtire!
          </div>

        </div>


        {/* =================================
            BOTTOM PADDING
        ================================= */}

        <div className="receipt-bottom-padding">

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />

        </div>

      </div>

    </div>

  );

};

export default ReceiptPreview;